<template>
  <div class="i-free-gift-included">
    <div class="badge unlock">You’ve Unlocked $250 in FREE ADD-ONS</div>
    <div class="bottom">
      <img
        class="tick"
        :src="props.resumeBuilderClaimed ? IconCheckboxFilled : IconCheckboxEmpty"
        @click="$emit('claim-resume-builder')"
      />
      <img
        class="resume"
        :src="ImageAI"
      />
      <div class="perks">
        <div class="offer">
          Offer ends in:
          <span class="timer">
            {{ props.minutesLeft }}:{{ parseInt(props.secondsLeft) < 10 ? "0" + props.secondsLeft : props.secondsLeft }}
          </span>
        </div>
        <div>The Ultimate Job-Ready Resume Package</div>
        <div class="more">
          <div class="price">
            <span class="free">FREE</span>
            <div class="badge save">SAVE <span class="dollar">$</span>250</div>
          </div>
          <div
            class="learn"
            @click="$emit('show-resume-builder-modal')"
          >
            Learn more
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// ASSETS
import IconCheckboxFilled from "@/assets/icons/icon-gradient-checkbox-filled.svg"
import IconCheckboxEmpty from "@/assets/icons/icon-gradient-checkbox-empty.svg"
import ImageAI from "@/assets/welcome/rb-ai-resume1.svg"

// EMITS
const emit = defineEmits(["show-resume-builder-modal", "claim-resume-builder"])

// PROPS
const props = defineProps({
  resumeBuilderClaimed: {
    type: Boolean,
    default: false
  },
  minutesLeft: { type: String, required: true },
  secondsLeft: { type: String, required: true }
})
</script>

<style scoped lang="scss">
.i-free-gift-included {
  @include flex(column, start, stretch, $gap: 16px);

  margin: 5px 0 6px;

  .badge {
    @include border-radius-xxl;

    background: linear-gradient(90deg, #9810fa 0%, #e60076 100%);
    color: $white;
    font-weight: 600;
  }

  .unlock {
    @include flex(row, center, center);
    @include text-xs;

    padding: 3px 16px;

    @media screen and (min-width: $breakpoint-sm) {
      @include text-sm;
    }
  }

  .bottom {
    @include flex(row, start, start, $gap: 12px);

    .tick {
      width: 18px;
      cursor: pointer;

      @media screen and (min-width: $breakpoint-sm) {
        width: 24px;
      }
    }

    .resume {
      @include border-radius-sm;

      width: 60px;

      @media screen and (min-width: $breakpoint-sm) {
        @include border-radius-md;

        width: 73px;
      }
    }

    .perks {
      @include text-sm;

      font-weight: 700;

      @media screen and (min-width: $breakpoint-sm) {
        @include text-md;
      }

      .offer {
        @include flex(row, start, center, $gap: 3px);
        @include text-xs;

        font-weight: 400;

        .timer {
          font-weight: 700;
          width: 40px;
        }
      }

      .more {
        @include flex(row, space-between, center, wrap, 2px 0);

        .price {
          @include flex(row, start, center, wrap, 0 5px);
          @include text-xs;

          font-weight: 600;

          .free {
            background: linear-gradient(90deg, #9810fa 0%, #e60076 100%);
            color: transparent;
            background-clip: text;
          }

          .save {
            padding: 0 5px;

            .dollar {
              @include text-xxs;
            }
          }
        }

        .learn {
          @include text-xs;

          color: $azure-radiance500;
          text-decoration: underline;
          cursor: pointer;

          @media screen and (min-width: $breakpoint-sm) {
            @include text-sm;
          }

          &:hover {
            color: $azure-radiance400;
          }
        }
      }
    }
  }
}
</style>
